/**
 * Constants for the Doctor working-hours editor — PROD-762 PR-B.
 *
 * `HOURS_LIST`, `MINUTES_LIST`, `WEEKDAYS`, `DEFAULT_HOUR` and `DEFAULT_MINUTE` GRADUATED into
 * Signal DS 1.45.0 (`organisms/WorkingHourBlock/working-hours-constants`) and are re-exported here
 * so this module keeps its existing importers unchanged. The local copies are deleted: they were a
 * verbatim shadow of the package, which is what `check-ds-shadows` exists to retire.
 *
 * Values verified identical to the package at runtime before the swap — these string formats are
 * LOAD-BEARING (the backend deserialises them on the PUT body for `DoctorWorkingHourSlot.startHour`
 * etc.), so a silent divergence between the two copies would have been a wire bug, not a style one.
 * Originally sourced verbatim from Flutter `scrips_core/lib/constants/app_constants.dart`
 * (`hoursList` dart:486-511, `minList()` dart:523-533, `weekList` dart:513-521).
 */
export {
  HOURS_LIST,
  MINUTES_LIST,
  WEEKDAYS,
  DEFAULT_HOUR,
  DEFAULT_MINUTE,
} from '@scripsteam/scrips-signal-ds';

/**
 * Doctor working-hours type enum. Practice has 3 types (Work/Holiday/Other);
 * Doctor surface has only 2 (Work/Vacation). Wire value is an integer.
 *
 * NOT in the design system — `dWHoursTypeList` (dart:543-546) has no package export, so this one
 * stays local and this file stays.
 */
export const DOCTOR_WH_TYPES: ReadonlyArray<{ value: number; name: string }> = [
  { value: 1, name: 'Work' },
  { value: 2, name: 'Vacation' },
];
